// Context-layer enums — client-side mirror of server/src/bidEstimation/models/contextEnums.js

// PARENT_TYPES
export const PARENT_TYPE = Object.freeze({
  ESTIMATE: 'estimate', DOCUMENT: 'document', SCOPE: 'scope', MODULE: 'module',
  ASSEMBLY: 'assembly', ASSEMBLY_ITEM: 'assembly_item', LINE_ITEM: 'line_item',
  SERVICE_TEMPLATE: 'service_template', VENDOR_QUOTE: 'vendor_quote',
  VENDOR_QUOTE_LINE: 'vendor_quote_line', OUTPUT_PACKAGE: 'output_package',
  OUTPUT_SECTION: 'output_section', TASK: 'task', BLOCKER: 'blocker', DECISION: 'decision'
})
export const PARENT_TYPE_LABELS = {
  estimate: 'Estimate', document: 'Document', scope: 'Scope', module: 'Module',
  assembly: 'Assembly', assembly_item: 'Assembly Item', line_item: 'Line Item',
  service_template: 'Service Template', vendor_quote: 'Vendor Quote',
  vendor_quote_line: 'Quote Line', output_package: 'Output Package',
  output_section: 'Output Section', task: 'Task', blocker: 'Blocker', decision: 'Decision'
}

// PRIORITY
export const PRIORITY = Object.freeze({ LOW: 'low', NORMAL: 'normal', HIGH: 'high', URGENT: 'urgent' })
export const PRIORITY_LABELS = { low: 'Low', normal: 'Normal', high: 'High', urgent: 'Urgent' }
export const PRIORITY_COLORS = { low: '#9e9e9e', normal: '#1976d2', high: '#ff9800', urgent: '#d32f2f' }

// NOTE_KIND
export const NOTE_KIND = Object.freeze({
  GENERAL: 'general', SCOPE: 'scope', PRICING: 'pricing', VENDOR: 'vendor',
  OUTPUT: 'output', CUSTOMER: 'customer', INTERNAL: 'internal', OTHER: 'other'
})
export const NOTE_KIND_LABELS = {
  general: 'General', scope: 'Scope', pricing: 'Pricing', vendor: 'Vendor',
  output: 'Output', customer: 'Customer', internal: 'Internal', other: 'Other'
}

// NOTE_VISIBILITY
export const NOTE_VISIBILITY = Object.freeze({ INTERNAL: 'internal', PROPOSAL_CANDIDATE: 'proposal_candidate' })
export const NOTE_VISIBILITY_LABELS = { internal: 'Internal', proposal_candidate: 'Proposal Candidate' }

// BLOCKER_STATUS
export const BLOCKER_STATUS = Object.freeze({
  OPEN: 'open', WAITING: 'waiting', ANSWERED: 'answered',
  RESOLVED: 'resolved', CANCELLED: 'cancelled', ARCHIVED: 'archived'
})
export const BLOCKER_STATUS_LABELS = {
  open: 'Open', waiting: 'Waiting', answered: 'Answered',
  resolved: 'Resolved', cancelled: 'Cancelled', archived: 'Archived'
}
export const BLOCKER_STATUS_COLORS = {
  open: '#ff9800', waiting: '#f57c00', answered: '#1976d2',
  resolved: '#2e7d32', cancelled: '#9e9e9e', archived: '#757575'
}

// BLOCKER_CATEGORY
export const BLOCKER_CATEGORY = Object.freeze({
  CUSTOMER_SELECTION: 'customer_selection', VENDOR_QUOTE: 'vendor_quote', RFI: 'rfi',
  INTERNAL_REVIEW: 'internal_review', APPROVAL: 'approval', MISSING_DOCUMENT: 'missing_document',
  SCOPE_GAP: 'scope_gap', PLAN_CONFLICT: 'plan_conflict', BID_REQUIREMENT: 'bid_requirement',
  OUTPUT_BLOCKER: 'output_blocker', OTHER: 'other'
})
export const BLOCKER_CATEGORY_LABELS = {
  customer_selection: 'Customer Selection', vendor_quote: 'Vendor Quote', rfi: 'RFI',
  internal_review: 'Internal Review', approval: 'Approval', missing_document: 'Missing Document',
  scope_gap: 'Scope Gap', plan_conflict: 'Plan Conflict', bid_requirement: 'Bid Requirement',
  output_blocker: 'Output Blocker', other: 'Other'
}

// DECISION_STATUS
export const DECISION_STATUS = Object.freeze({
  ACTIVE: 'active', SUPERSEDED: 'superseded', REVERSED: 'reversed', ARCHIVED: 'archived'
})
export const DECISION_STATUS_LABELS = { active: 'Active', superseded: 'Superseded', reversed: 'Reversed', archived: 'Archived' }
export const DECISION_STATUS_COLORS = { active: '#1976d2', superseded: '#9e9e9e', reversed: '#f44336', archived: '#757575' }

// DECISION_TYPE
export const DECISION_TYPE = Object.freeze({
  PRICING_ASSUMPTION: 'pricing_assumption', SCOPE_ASSUMPTION: 'scope_assumption',
  VENDOR_SELECTION: 'vendor_selection', OUTPUT_NOTE: 'output_note', EXCLUSION: 'exclusion',
  ALLOWANCE: 'allowance', RISK_ACCEPTANCE: 'risk_acceptance', OTHER: 'other'
})
export const DECISION_TYPE_LABELS = {
  pricing_assumption: 'Pricing Assumption', scope_assumption: 'Scope Assumption',
  vendor_selection: 'Vendor Selection', output_note: 'Output Note', exclusion: 'Exclusion',
  allowance: 'Allowance', risk_acceptance: 'Risk Acceptance', other: 'Other'
}

// REVIEW_EVENT_STATUS
export const REVIEW_EVENT_STATUS = Object.freeze({
  SCHEDULED: 'scheduled', COMPLETED: 'completed', CANCELLED: 'cancelled', MISSED: 'missed', ARCHIVED: 'archived'
})
export const REVIEW_EVENT_STATUS_LABELS = { scheduled: 'Scheduled', completed: 'Completed', cancelled: 'Cancelled', missed: 'Missed', archived: 'Archived' }
export const REVIEW_EVENT_STATUS_COLORS = { scheduled: '#1976d2', completed: '#2e7d32', cancelled: '#9e9e9e', missed: '#f44336', archived: '#757575' }

// REVIEW_EVENT_TYPE
export const REVIEW_EVENT_TYPE = Object.freeze({
  INTERNAL_REVIEW: 'internal_review', VENDOR_REVIEW: 'vendor_review',
  CUSTOMER_REVIEW: 'customer_review', GC_REVIEW: 'gc_review', OUTPUT_REVIEW: 'output_review', OTHER: 'other'
})
export const REVIEW_EVENT_TYPE_LABELS = {
  internal_review: 'Internal Review', vendor_review: 'Vendor Review',
  customer_review: 'Customer Review', gc_review: 'GC Review', output_review: 'Output Review', other: 'Other'
}

// CONVERSATION_TYPE
export const CONVERSATION_TYPE = Object.freeze({
  CALL: 'call', EMAIL: 'email', MEETING: 'meeting', SITE_VISIT: 'site_visit', OTHER: 'other'
})
export const CONVERSATION_TYPE_LABELS = {
  call: 'Call', email: 'Email', meeting: 'Meeting', site_visit: 'Site Visit', other: 'Other'
}

// TASK_TYPE
export const TASK_TYPE = Object.freeze({
  REVIEW: 'review', QUOTE_REQUEST: 'quote_request', TAKEOFF: 'takeoff', PRICING: 'pricing',
  OUTPUT: 'output', CUSTOMER_FOLLOWUP: 'customer_followup', VENDOR_FOLLOWUP: 'vendor_followup',
  INTERNAL_FOLLOWUP: 'internal_followup', OTHER: 'other'
})
export const TASK_TYPE_LABELS = {
  review: 'Review', quote_request: 'Quote Request', takeoff: 'Takeoff', pricing: 'Pricing',
  output: 'Output', customer_followup: 'Customer Follow-up', vendor_followup: 'Vendor Follow-up',
  internal_followup: 'Internal Follow-up', other: 'Other'
}
